module.exports = __webpack_public_path__ + "img/creditcard-front.c134509a.png";